<template>
  <div class="main">
    <div class="title">
      <p class="en">MAIN BUSINESS</p>
      <p class="cn">{{$t("home.main.title")}}</p>
    </div>
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="8">
          <router-link to="/main">
            <div class="item item1">
              <div class="itemIE11">
                <div class="num">01</div>
                <div class="line">|</div>
                <div class="text">{{$t("home.main.text1")}}</div>
                <div class="btn-go">{{$t("home.main.btn")}}</div>
              </div>
            </div>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link to="/main/hotel">
            <div class="item item2">
              <div class="itemIE11">
                <div class="num">02</div>
                <div class="line">|</div>
                <div class="text">{{$t("home.main.text2")}}</div>
                <div class="btn-go">{{$t("home.main.btn")}}</div>
              </div>
            </div>
          </router-link>
        </el-col>
        <el-col :span="8">
          <div class="item3">
            <router-link to="/main/market">
              <div class="item item3-1">
                <div class="itemIE11">
                  <div class="num">03</div>
                  <div class="text">{{$t("home.main.text3")}}</div>
                  <div class="btn-go">{{$t("home.main.btn")}}</div>
                </div>
              </div>
            </router-link>
            <router-link to="/main/property">
              <div class="item item3-2">
                <div class="itemIE11">
                  <div class="num">04</div>
                  <div class="text">{{$t("home.main.text4")}}</div>
                  <div class="btn-go">{{$t("home.main.btn")}}</div>
                </div>
              </div>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  a
    color #FFF
  .title
    width 100%
    text-align center
    padding-bottom 30px
    .en
      en()
      font-size 40px
    .cn
      cn()
      font-size 24px
  .main
    padding-top 138px
    normalContainer()
    .container
      color #fff
      font-size 30px
      .item:before
        position absolute
        top 0
        left 0
        content ''
        width 100%
        height 100%
        background #000
        opacity 0.3
        transition opacity .5s
      .item:hover:before
        opacity 0
      .item:hover
        .btn-go
          color #000
          border 2px solid $navBgColor2
          background $navBgColor2
      .item
        setHeight()
        fullBg()
        cursor pointer
        position relative
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .num
          margin-bottom  35px
        .line
          width 3px
          font-size 50px
          margin-bottom  35px
          position relative
          left -6px
        .text
          margin-bottom  45px
        .btn-go
          border 2px solid #FFF
          font-size 15px
          padding 15px 30px
          box-sizing border-box
      .item1,.item2
        padding 50% 0
      .item1
        background-image url("~assets/home/main1.jpg")
      .item2
        background-image url("~assets/home/main2.jpg")
      .item3
        position relative
        left -0.5px
      .item3-1,.item3-2
        padding 25% 0
      .item3-1
        background-image url("~assets/home/main3.jpg")
      .item3-2
        background-image url("~assets/home/main4.jpg")
  .itemIE11
    flexColumn()
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Main.vue